import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { createBrand, updateBrand } from '../services/api';
import { getApiErrorMessage } from '../utils/apiError';

export default function BrandFormDialog({ open, brand, onClose, onSaved }) {
  const isEdit = !!brand?.id;
  const [descricao, setDescricao] = useState('');
  const [touched, setTouched] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setDescricao(brand?.descricao || '');
    setTouched(false);
    setSaving(false);
    setError('');
  }, [open, brand]);

  const descricaoInvalida = !descricao.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (descricaoInvalida) return;

    setSaving(true);
    setError('');
    try {
      const payload = { descricao: descricao.trim() };
      if (isEdit) {
        await updateBrand(brand.id, { id: brand.id, ...payload });
        onSaved?.('Marca atualizada', { id: brand.id, ...payload });
      } else {
        const { data } = await createBrand(payload);
        onSaved?.('Marca criada', data);
      }
    } catch (err) {
      setError(getApiErrorMessage(err, 'Erro ao salvar a marca.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ component: 'form', onSubmit: handleSubmit }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
        <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="h6" fontWeight={800} noWrap>
            {isEdit ? 'Editar marca' : 'Nova marca'}
          </Typography>
        </Stack>
        <IconButton onClick={onClose} disabled={saving} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Descrição"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            onBlur={() => setTouched(true)}
            error={touched && descricaoInvalida}
            helperText={touched && descricaoInvalida ? 'Informe a descrição.' : ' '}
            autoFocus
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={saving}>
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isEdit ? 'Salvar' : 'Criar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
